import { html } from '../core/html.js';
import { icon } from './icon.js';
import { t } from '../core/i18n.js';

/**
 * Store buttons for a title. Renders nothing when a title has no stores yet —
 * callers decide what to show instead, so there is no empty disabled button.
 */
export const storeLinks = (title, stores) => {
  const entries = [
    stores.play && { href: stores.play, label: t('store.play'), glyph: 'play' },
    stores.ios && { href: stores.ios, label: t('store.ios'), glyph: 'apple' },
  ].filter(Boolean);

  if (!entries.length) return '';

  return html`
    <div class="store-links">
      ${entries.map(
        (entry) => html`
          <a
            class="store-btn"
            href="${entry.href}"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="${t('store.openIn', { title, store: entry.label })}"
          >
            ${icon(entry.glyph, { size: 14 })}<span>${entry.label}</span>
          </a>
        `,
      )}
    </div>
  `;
};
